import { api } from "@api/api";
import { appendFormData } from "@core/utils/appendFormData";
import { User } from "@modules/users/types/user";
import { CreateUserFormValues } from "@modules/users/validations/createUserSchama";

export async function createUserService(
  data: CreateUserFormValues
): Promise<User> {
  const formatedData = appendFormData(data);
  const headers: any =
    formatedData instanceof FormData
      ? { "Content-Type": "multipart/form-data" }
      : { "Content-Type": "application/json" };

  const { data: user } = await api.post<User>("v1/user_admin/", formatedData, {
    headers,
  });

  return user;
}
